import React from 'react';
import { MapPin, Building2, Bus, ExternalLink } from 'lucide-react';
import './Location.css';

function Location() {
  return (
    <div className="location-page">
      <div className="container">
        <section className="page-hero">
          <h1>Location</h1>
          <p className="subtitle">
            Our group is based at the Center for Theoretical Physics (CTP PAS), 
            located on the campus of the Institute of Physics, Polish Academy of Sciences in Warsaw.
          </p>
        </section>

        <section className="section">
          <div className="location-grid">
            {/* Map */}
            <div className="location-map">
              <iframe
                title="CTP PAS Location"
                src="https://www.openstreetmap.org/export/embed.html?bbox=21.002%2C52.174%2C21.014%2C52.180&layer=mapnik&marker=52.17712219447016%2C21.00820294439891"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: 'var(--radius-lg)' }}
                loading="lazy"
                allowFullScreen
              />
            </div>

            {/* Info */}
            <div className="location-info">
              <div className="location-card">
                <div className="location-card-icon">
                  <Building2 size={24} />
                </div>
                <h3>Address</h3>
                <p>
                  Center for Theoretical Physics<br />
                  Polish Academy of Sciences<br />
                  Al. Lotników 32/46<br />
                  02-668 Warsaw, Poland
                </p>
              </div>

              <div className="location-card">
                <div className="location-card-icon">
                  <MapPin size={24} />
                </div>
                <h3>Campus</h3>
                <p>
                  We are located on the campus of the Institute of Physics PAS (IF PAN) 
                  in the Mokotów district of Warsaw.
                </p>
              </div>

              <div className="location-card">
                <div className="location-card-icon">
                  <Bus size={24} />
                </div>
                <h3>Getting Here</h3>
                <p>
                  Accessible by tram and bus. Nearest stops: "rondo Unii Europejskiej" and "Al. Lotników."
                </p>
              </div>

              <div className="location-links">
                <a
                  href="https://www.google.com/maps?q=52.17712219447016,21.00820294439891"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-ghost"
                >
                  Open in Google Maps <ExternalLink size={14} />
                </a>
                <a
                  href="https://www.cft.edu.pl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-ghost"
                >
                  CTP PAS Website <ExternalLink size={14} />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Location;
